export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4757.f76c75e2.jpg";